import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Page from 'components/Page';
import CountriesList from 'components/CountriesList';
import Pagination from 'components/Pagination';
import Search from 'components/Search';

import { makeAfter, withData } from 'lib';
import { SettingsCountryListPageQuery } from '__generated__/SettingsCountryListPageQuery.graphql';

const query = graphql`
  query SettingsCountryListPageQuery(
    $first: Int!
    $after: String
    $search: String
  ) {
    ...CountriesList_data
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<SettingsCountryListPageQuery>;
};

const SettingsCateringListPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<SettingsCountryListPageQuery>(
    query,
    preloadedQuery
  );

  return (
    <Page
      breadcrumbs={[
        { link: '/settings', name: 'Nustatymai' },
        { name: 'Vietos' },
      ]}>
      <Pagination>
        <Search>
          <CountriesList data={data} />
        </Search>
      </Pagination>
    </Page>
  );
};

export default withData<SettingsCountryListPageQuery>({
  query,
  reloadOnRender: false,
  variables: ({ currentUser, searchParams }) => ({
    first: currentUser.itemsPerPage,
    after: makeAfter(
      Number(searchParams.get('page')) || 0,
      currentUser.itemsPerPage
    ),
  }),
})(SettingsCateringListPage);
